import '@js/utilities/scrollEvents';

// import formValidationHandler from '@js/utilities/formValidation';
import lozad from 'lozad';
import '@js/utilities/dragToScroll';
import '@js/vendors/bootstrap';
import { sessionListener } from '@js/utilities/session/session';
// import { authService } from '@js/utilities/auth/authService';
import { bootstrapModulesController } from '@js/utilities/bootstrap-modules-controller/bootstrapModulesController';
import '@js/vendors/klaro';

import { ajaxFormListener } from '@js/utilities/ajax/ajaxForm';

import('@js/abstracts/videoPlayerLazy');

const observer = lozad('.lozad');

import('@js/entrypoints/modals/selectLanguage');

window.gridBreakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1320,
    xxl: 1400,
    xxxl: 1600,
};

async function loadSentry() {
    const Sentry = await import('@sentry/browser');
    // const { BrowserTracing } = await import('@sentry/tracing');
    const { Replay, ReplayCanvas, BrowserTracing } = await import('@sentry/browser');
    const { CaptureConsole } = await import('@sentry/integrations');

    Sentry.init({
        dsn: 'https://dba7739a3eac4e599b122f9f90cf1897@sentry.sylapi.com/5',
        release: window.config.build,
        environment: window.config.environment,
        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: window.config.environment !== 'production' ? 1.0 : 0.001,
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,
        integrations: [
            new Replay({
                maskAllText: false,
                blockAllMedia: false,
                maskAllInputs: true,
            }),
            new ReplayCanvas(),
            new BrowserTracing(),
            new CaptureConsole({
                levels: ['error'],
            }),
        ],
        beforeSend(event) {
            // Check if it is an exception, and if so, show the report dialog
            if (event.exception && true === false) {
                // Sentry.showReportDialog({
                //     eventId: event.event_id,
                //     title: window.translate('error_report_modal.title'),
                //     subtitle: window.translate('error_report_modal.subtitle'),
                //     subtitle2: window.translate('error_report_modal.subtitle2'),
                //     labelEmail: window.translate('error_report_modal.labelEmail'),
                //     labelName: window.translate('error_report_modal.labelName'),
                //     labelComments: window.translate('error_report_modal.labelComments'),
                //     labelClose: window.translate('error_report_modal.labelClose'),
                //     labelSubmit: window.translate('error_report_modal.labelSubmit'),
                //     errorGeneric: window.translate('error_report_modal.errorGeneric'),
                //     errorFormEntry: window.translate('error_report_modal.errorFormEntry'),
                //     successMessage: window.translate('error_report_modal.successMessage'),
                // });
            }
            return event;
        },
        tracesSampleRate: window.config.environment !== 'production' ? 1.0 : 0.01,
    });
}

function reportWebVital(data) {
    if (
        (data.name === 'CLS' && data.delta < 0.1) ||
        (data.name === 'FID' && data.delta < 100) ||
        (data.name === 'LCP' && data.delta < 2500)
    ) {
        return;
    }

    console.warn({ name: data.name, value: data.value, delta: data.delta });
    console.table(data.entries);
}

async function loadWebVitals() {
    const { getLCP, getFID, getCLS } = await import('web-vitals');

    getCLS(reportWebVital);
    getFID(reportWebVital);
    getLCP(reportWebVital);
}

let userInteracted = false;

async function firstInteraction() {
    if (!userInteracted) {
        userInteracted = true;

        // load sentry in environments other than local
        if (window.config.environment !== 'local') {
            loadSentry();
        }

        // loadSentry();
    }
}

['click', 'scroll', 'mousemove', 'touchstart'].forEach(async (e) => {
    window.addEventListener(e, firstInteraction, {
        once: true,
    });
});

// web vitals measuring are useful during development
if (window.config.environment !== 'production') {
    loadWebVitals();
}

// Extend "document" object to function
// That allow listen events in "live" mode.
// If new element appears in DOM,
// event from "addRemoteEventListener" method
// will be attached automatically
// to matching element.
function live(eventType, elementSelector, cb) {
    document.addEventListener(eventType, (event) => {
        const toggler = event.target.closest(elementSelector);

        if (toggler) {
            event.preventDefault();
            cb.call(toggler, { ...event, target: toggler });
        }
    });
}

Document.prototype.addRemoteEventListener = live;

if (navigator.userAgent.match(/chrome|chromium|crios/i)) {
    window.BROWSER = 'chrome';
} else if (navigator.userAgent.match(/firefox|fxios/i)) {
    window.BROWSER = 'firefox';
} else if (navigator.userAgent.match(/safari/i)) {
    window.BROWSER = 'safari';
} else if (navigator.userAgent.match(/opr\//i)) {
    window.BROWSER = 'opera';
} else if (navigator.userAgent.match(/edg/i)) {
    window.BROWSER = 'edge';
} else {
    window.BROWSER = null;
}

function detectMob() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
}

function detectIos() {
    const toMatch = [/iPhone/i, /iPad/i, /iPod/i];

    return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
}

window.IS_MOBILE = detectMob();
window.IS_IOS = detectIos();

/**
 * Events run when page is loaded and remote content is loaded (like modals etc)
 */
['DOMContentLoaded', 'RemoteContentLoaded'].forEach((event) =>
    window.addEventListener(event, async () => {
        // const container = e.container ?? null;

        // Init custom validation of forms
        // formValidationHandler(container);
        sessionListener();

        bootstrapModulesController();

        ajaxFormListener();

        observer.observe();

        // Init input[type="tel"]
        // const telInputHandler = await import('@js/utilities/inputTel');
        // // const telInputHandler = await loadModules();
        // telInputHandler.default(container);
    })
);

window.addEventListener('DOMContentLoaded', async () => {
    // handleMe();
    document.body.classList.add(`on-${window.IS_MOBILE ? 'mobile' : 'desktop'}`);

    if (window.IS_IOS === true) {
        document.body.classList.add(`on-ios`);
    }

    document.body.classList.add(`on-${window.BROWSER}`);
});
